<template>
    <a-layout-header
        v-if="headerShowType>0 && !headerBarFixed"
        :class="[fixedHeader && 'ant-header-fixedHeader', sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed', moduleGroup==1?'':((device === 'desktop' && headerShowType===1)?'topbar':'empty-topBar') ]"
        :style="{ padding: '0' }">
        <div v-if="mode === 'sidemenu'" :class="theme">
            <a-icon
                v-if="device==='mobile'"
                class="trigger"
                :type="collapsed ? 'menu-fold' : 'menu-unfold'"
                @click="toggle">
            </a-icon>
            <a-icon
                v-else
                class="trigger"
                :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                @click="toggle"/>
            <span v-if="device === 'desktop'">欢迎进入 {{name}}</span>
            <span v-else>{{enName}}</span>
            <user-menu :theme="theme"/>
        </div>
        <!-- 顶部导航栏模式 start -->
        <div v-else :class="['webheader', theme]">
            <div class="webheader-wide">
                <div class="webheader-wide-left" :style="topMenuStyle.headerIndexLeft">
                    <logo :class="['webheader-wide-left-logo']" :show-title="true" :style="topMenuStyle.topNavHeader" :moduleGroup="moduleGroup"></logo>
                    <div v-if="device !== 'mobile'" :style="topMenuStyle.topSmenuStyle">
                        <s-menu
                            mode="horizontal"
                            :menu="menus"
                            :theme="theme"/>
                    </div>
                    <a-icon
                        v-else
                        class="trigger"
                        :type="collapsed ? 'menu-fold' : 'menu-unfold'"
                        @click="toggle"></a-icon>
                </div>
                <user-menu :class="'webheader-wide-right'" :theme="theme" :style="topMenuStyle.headerIndexRight" :moduleGroup="moduleGroup"/>
            </div>
        </div>
        <!-- 顶部导航栏模式 end -->
    </a-layout-header>
</template>




<script>

    import UserMenu from '../tools/UserMenu';
    import SMenu from '../menu/';
    import Logo from '../tools/Logo';
    import { mixin } from '@/utils/mixin.js';

    export default {
        name: "PageHeader",
        components: {
            UserMenu,
            SMenu,
            Logo,
        },
        mixins: [mixin],
        props: {
            mode: {
                type: String,
                // sidemenu, topmenu
                default: 'sidemenu'
            },
            menus: {
                type: Array,
                required: true
            },
            theme: {
                type: String,
                required: false,
                default: 'dark'
            },
            collapsed: {
                type: Boolean,
                required: false,
                default: false
            },
            device: {
                type: String,
                required: false,
                default: 'desktop'
            },

            // ----------------------------------------------------------------------- 开发Web增加的 start
            headerShowType: {
                type: Number,
                required: false,
                default: 1,                                     // 0=不显示， 1=有背景的， 2=没有背景的
            },
            moduleGroup: {
                type: Number,
                required: false,
                default: 1,                                     // 功能模块组别：1=后台，2=web
            }
            // ----------------------------------------------------------------------- 开发Web增加的 end
        },
        data() {
            return {
                headerBarFixed: false,
                topMenuStyle: {
                    headerIndexLeft: {},
                    topNavHeader: {},
                    headerIndexRight: {},
                    topSmenuStyle: {}
                },
                chatStatus: '',

                name: '',
                enName: '',

            }
        },
        watch: {
            /** 监听设备变化 */
            device() {
                if (this.mode === 'topmenu') {
                    this.buildTopMenuStyle()
                }
            },
            /** 监听导航栏模式变化 */
            mode(newVal) {
                if (newVal === 'topmenu') {
                    this.buildTopMenuStyle()
                }
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll)
            //  顶部导航栏过长时显示更多按钮
            if (this.mode === 'topmenu') {
                this.buildTopMenuStyle()
            }
        },
        created() {
            this.name = window._CONFIG['name'];
            this.enName = window._CONFIG['enName'];
            this.headerInit();
        },
        methods: {
            headerInit: function() {
                console.log('theme mode  = ' + this.mode);
            },
            handleScroll() {
                if (this.autoHideHeader) {
                    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                    if (scrollTop > 100) {
                        this.headerBarFixed = true
                    } else {
                        this.headerBarFixed = false
                    }
                } else {
                    this.headerBarFixed = false
                }
            },
            toggle() {
                this.$emit('toggle')
            },
            /**  顶部导航栏过长时显示更多按钮 */
            buildTopMenuStyle() {
                if (this.mode === 'topmenu') {
                    if (this.device === 'mobile') {
                        // 手机端需要清空样式，否则显示会错乱
                        this.topMenuStyle.topNavHeader = {}
                        this.topMenuStyle.topSmenuStyle = {}
                        this.topMenuStyle.headerIndexRight = {}
                        this.topMenuStyle.headerIndexLeft = {}
                    } else {
                        let rightWidth = '360px'
                        this.topMenuStyle.topNavHeader = { 'min-width': '140px' }
                        this.topMenuStyle.topSmenuStyle = { 'width': 'calc(100% - 140px)' }
                        this.topMenuStyle.headerIndexRight = { 'min-width': rightWidth }
                        this.topMenuStyle.headerIndexLeft = { 'width': `calc(100% - ${rightWidth})` }
                    }
                }
            }
        }
    }



</script>





<style lang="less" scoped>
    // --------------------------------------- topbar start
    @WebTopBarHeight: 40px;
    .topbar{
        height: @WebTopBarHeight !important;
    }
    .empty-topBar {
        height: @WebTopBarHeight !important;
    }
    // --------------------------------------- topbar end

    .trigger{
        color: white;
        font-size: 22px;
        line-height: 42px;
        padding: 0 18px;
        cursor: pointer;
        transition: color 300ms, background 300ms;

        &:hover {
            background: rgba(255, 255, 255, 0.3);
        }
    }

    .webheader {
        box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
        position: relative;
        transition: background .3s, width .2s;
        .webheader-wide {
            width: 100%;
            height: 40px !important;
            line-height: 40px !important;
            margin: auto;
            padding: 0 20px 0 0;
            display: flex;
            .webheader-wide-left {
                flex: 1 1;
                display: flex;
                .webheader-wide-left-logo {
                    width: 140px;
                    height: 40px;
                    position: relative;
                    line-height: 40px;
                    transition: all .3s;
                    overflow: hidden;
                    padding-left: 10px;
                    /deep/ img {
                        display: inline-block;
                        vertical-align: middle;
                        height: 32px;
                    }
                    /deep/ h1 {
                        color: #fff;
                        display: inline-block;
                        vertical-align: top;
                        font-size: 16px;
                        margin: 0 0 0 12px;
                        font-weight: 400;
                    }
                }
                // 下拉菜单的UL
                /deep/ ul {
                    height: 40px !important;
                }
            }
            // 右边
            .webheader-wide-right {
                float: right;
                height: 40px;
                overflow: hidden;
                text-align: right;
                // 右边的下拉菜单
                /deep/ .action:hover {
                    background-color: rgba(0, 0, 0, 0.05);
                }
                /deep/ .action {
                    color: white !important;
                    cursor: pointer !important;
                    padding: 0 14px !important;
                    display: inline-block !important;
                    transition: all .3s !important;

                    height: 70% !important;
                    line-height: 40px !important;

                    &.action-full {
                        height: 100% !important;
                    }

                    &:hover {
                        background: rgba(255, 255, 255, 0.3) !important;
                    }

                    .avatar {
                        margin: 00px 0px 0px 0 !important;
                        color: #1890ff !important;
                        background: hsla(0, 0%, 100%, .85) !important;
                        vertical-align: middle !important;
                    }

                    .icon {
                        font-size: 16px !important;
                        padding: 4px !important;
                    }

                    .anticon {
                        color: inherit !important;
                    }
                }
            }
        }
    }




</style>
